import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RangedResultChartComponent } from '../ranged-result-chart/ranged-result-chart.component';
import { ResultTableComponent } from '../result-table/result-table.component';

@Component({
  selector: 'app-ranged-result',
  templateUrl: './ranged-result.component.html',
  styleUrls: ['./ranged-result.component.css']
})
export class RangedResultComponent implements OnInit {

  @Input() solverResultsAndConditonsAndRangeVariable;
  @ViewChild('chart',{static:true}) chart:RangedResultChartComponent;
  @ViewChild("resultTable") resultTable:ResultTableComponent;

  constructor() {}

  ngOnInit() {
  }

  selection(seriesSelection){
    this.chart.setSeriesSelection(seriesSelection);
  }

  pinSelection(seriesSelection){
    this.chart.setPinnedSelection(seriesSelection);
  }

  clearPinnedSelection(){
    this.chart.clearPinnedSelection();
  }

  clone(obj:any):any{
    return JSON.parse(JSON.stringify(obj));
  }

}
